// traceability: requirements: [NFR-001, NFR-015]
import type common from '@/i18n/locales/en/common.json';

export type TranslationKeys = keyof typeof common;

export type SupportedLanguage = 'en' | 'ru' | 'he';

export type TextDirection = 'ltr' | 'rtl';

export const SUPPORTED_LANGUAGES: { code: SupportedLanguage; label: string; dir: TextDirection }[] = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'ru', label: 'Русский', dir: 'ltr' },
  { code: 'he', label: 'עברית', dir: 'rtl' },
];

export const RTL_LANGUAGES: SupportedLanguage[] = ['he'];

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'common';
    resources: {
      common: typeof common;
    };
  }
}
